import React from "react";
import { Input } from "../Input/Input";

const YourBudget = ({ handleChange, sectionStyles, formData, errors }) => {
  const weddingBudgetOptions = [
    { label: "Under $10,000", value: "Under 10000" },
    { label: "$10,000 - $20,000", value: "10000-20000" },
    { label: "$20,000 - $30,000", value: "20000-30000" },
    { label: "$30,000 - $50,000", value: "30000-50000" },
    { label: "$50,000+", value: "50000 plus" },
  ];

  const spendingPriorityOptions = [
    { label: "Venue", value: "venue" },
    { label: "Food", value: "food" },
    { label: "Photography", value: "photography" },
    { label: "Entertainment", value: "entertainment" },
    { label: "Decor", value: "decor" },
  ];
  return (
    <section className={`p-3 mb-14 lg:mb-6 ${sectionStyles.alignSection}`}>
      <h3 className="text-left text-2xl font-semibold">
        Your <span className="uppercase">Budget</span>
      </h3>

      <div className="space-y-6">
        {/* Budget Radio Group */}
        <div>
          <p className="font-medium mb-6">
            <span className="text-xl font-semibold">Do you have a set budget for the wedding?</span>
            <br />
            <span className="font-normal text-xl text-gray-500">
              (This helps guide our recommendations and priorities.)
            </span>
          </p>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {weddingBudgetOptions.map((option) => (
              <Input
                key={option.value}
                title={option.label}
                type="radio"
                name="weddingBudget"
                value={option.value}
                handleChange={handleChange}
                sectionStyles={sectionStyles.label}
                className={sectionStyles.checkbox}
                // error={errors.weddingBudget}
                checked={formData.weddingBudget === option.value}
              />
            ))}

            {/* "Other" Option */}
            <div className="flex items-center col-span-2 md:col-span-2 lg:col-span-3">
              <Input
                title="Other:"
                type="text"
                name="weddingBudgetOtherDescription"
                value={formData.weddingBudgetOtherDescription || ""}
                handleChange={handleChange}
                divClassName="w-full"
                sectionStyles={sectionStyles.label}
                className="flex-1 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
              />
            </div>

            {/* {(errors.weddingBudget || errors.weddingBudgetOtherDescription) && (
              <p className="text-red-500 text-sm">
                {errors.weddingBudget || errors.weddingBudgetOtherDescription}
              </p>
            )} */}
          </div>
        </div>

        {/* Spending Priorities Checkboxes */}
        <div>
          <p className={`font-semibold text-xl mb-4 ${sectionStyles.label}`}>
            Are there any specific areas of your wedding where you want to prioritize spending?
          </p>
          <div className="flex-row sm:justify-between items-center flex flex-wrap lg:gap-5 gap-4">
            {spendingPriorityOptions.map((option) => (
              <Input
                key={option.value}
                title={option.label}
                type="checkbox"
                name="spendingPriority"
                value={option.value}
                handleChange={handleChange}
                sectionStyles={sectionStyles.label}
                className={`${sectionStyles.checkbox}`}
                checked={formData.spendingPriority?.includes(option.value)}
              />
            ))}

            {/* "Other" Option */}
              <Input
                title="Other:"
                type="text"
                name="spendingPriorityOtherDescription"
                value={formData.spendingPriorityOtherDescription || ""}
                handleChange={handleChange}
                sectionStyles={sectionStyles.label}
                divClassName="w-full"
                className="flex-1 border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
              />
            
          </div>
          {/* {(errors.spendingPriority || errors.spendingPriorityOtherDescription) && (
              <p className="text-red-500 text-sm">
                {errors.spendingPriority || errors.spendingPriorityOtherDescription}
              </p>
            )} */}
        </div>

        {/* Additional Notes */}
        <div className="pt-2">
          <Input
            title="Additional Notes on Budgeting or Financial Considerations:"
            type="textarea"
            name="budgetNotes"
            value={formData.budgetNotes || ""}
            handleChange={handleChange}
            sectionStyles={`font-semibold text-xl ${sectionStyles.label}`}
            className="mt-2 w-full border-b border-gray-400 focus:outline-none focus:ring-0 focus:border-black"
            rows="4"
          />
        </div>
      </div>
    </section>
  );
};

export default YourBudget;
